<template >
  <b-container fluid>
    <b-row align-h="center" v-if="formas[0] != null">
        <b-col class="mt-3">
            <h5 style="color: #312bb5;" ><b-icon icon="table"/> Resultados de la Búsqueda</h5>    
        </b-col>
    </b-row>
    <b-row v-if="formas[0] != null ">
        <b-col cols="12" md="12" class="mt-2 mb-4">
            <b-alert variant="danger" :show="msgFormasCancelar != ''" dismissible>{{msgFormasCancelar}}</b-alert>
            <b-table style="min-height:450px;" v-if="formas[0] != null && formas.length < 500" responsive sticky-header  small :items="formas" :fields="fieldsToShow" :busy="isConsultando">
                <template v-slot:table-busy>
                    <div class="text-center text-secondary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                    </div>
                </template>
                <template v-slot:cell(folioOrden)="row">
                    <b-badge class="badge-ok" v-if="row.item.folioOrden!='NO GENERADA'" >{{row.item.folioOrden}}</b-badge>
                    <b-badge class="badge-error" v-if="row.item.folioOrden=='NO GENERADA'" >{{row.item.folioOrden}}</b-badge>
                </template>

                <template v-slot:cell(folioRecibo)="row">
                    <b-badge class="badge-ok" v-if="row.item.folioRecibo!='NO PAGADO'" >{{row.item.folioRecibo}}</b-badge>
                    <b-badge class="badge-error" v-if="row.item.folioRecibo=='NO PAGADO'" >{{row.item.folioRecibo}}</b-badge>
                </template>

               <template v-slot:cell(urlExpediente)="row">
                    <b-row   v-if="row.item.urlExpediente!=null && row.item.urlExpediente!=''" align-h="center" align="center">
                        <b-col style="cursor:pointer;">
                            <b-icon style="cursor:pointer;"  icon="archive-fill" variant="secondary" @click="mostrarExpedienteTramite(row.item.urlExpediente)"/>
                            <!-- <b-icon style="cursor:pointer;"  icon="share-fill" variant="secondary" class="ml-2" /> -->
                        </b-col>
                    </b-row>
                </template>

                <template v-slot:cell(nombre)="row">
                    <b-icon style="color:gray;" icon="person-circle"/> {{row.item.nombre}}
                </template>

                <template v-slot:cell(concepto)="row">
                    <b-icon style="color:gray;" icon="file-text"/> {{row.item.concepto}}
                </template>

                <template v-slot:cell(acciones)="row">
                    <b-dropdown id="dropdown-1"  variant="link" size="sm" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <b-icon style="color:gray;" icon="three-dots"/>
                        </template>
                        <b-dropdown-item  @click="reimprimirDocs(row.item.folioOrden, row.item.folioRecibo)"><b-icon icon="search"/> Consultar</b-dropdown-item>
                        <b-dropdown-item  @click="showDetalles(row.item.folioOrden, row.item.folioRecibo)"><b-icon icon="file-spreadsheet"/> Detalles</b-dropdown-item>                        
                        <b-dropdown-item  @click="cancelarTramite(row.item)"><b-icon icon="x-circle"/> Cancelar</b-dropdown-item>
                        <b-dropdown-item  v-if="row.item.folioRecibo!='NO PAGADO'" @click="showEnviarCorreo(row.item.folioRecibo)"><b-icon icon="envelope"/> Enviar Recibo</b-dropdown-item>
                        <b-dropdown-item  v-if="row.item.folioRecibo!='NO PAGADO' && (row.item.urlExpediente==null || row.item.urlExpediente=='') && (catalogFormas.tramitesInfo!=null && catalogFormas.tramitesInfo.length>0)" @click="mostrarCrearTramite(row.item.folioOrden, row.item.folioRecibo)"><b-icon icon="archive"/> Crear Expediente</b-dropdown-item>
                        
                    </b-dropdown>
                </template>
            </b-table>
            <b-col cols="12">
                <b-row align-h="end">
                    <b-col>
                        <div v-if="formas[0] != null">
                            <b-button variant="outline-info">
                            <downloadExcel :data= "formas" :fields="fieldsToExport" name="tramites.xls" worksheet="Tramites">
                                <b-icon icon="file-spreadsheet"/> Descargar Excel 
                            </downloadExcel>
                            </b-button>
                            <br>
                        </div>
                        <br>
                        <div v-if="formasClasificado != null">                           
                            <b-button  size="sm" variant="info" @click="descargarExcel">Descargar Excel Clasificado <b-icon icon="file-earmark-spreadsheet" font-scale="1.1"/></b-button>
                            <br>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-col>
    </b-row>

    
    
    <canvas v-show="false" id="barcode"></canvas>
    <!--modals-->

    <b-modal v-model="isShowModalDetalles" title="Detalles del Pago" size="xl" hide-footer header-bg-variant="dark" header-text-variant="light">

        <b-row style="padding:9px;">
            <b-col class="card-form-blue mt-5 mb-4">
                <b-row>
                    <b-col class="mt-3" cols="12">
                        <h5 style="color: #2A59B7;" ><b-icon icon="table"/> Liquidación</h5>    
                    </b-col>
                    <b-col >
                        <b-table stacked="lg"  responsive small striped :fields="fieldsTableDetallePago" :items="dataTableDetallePago">
                            <template #cell(extras)="row">
                                <b-button variant="success" size="sm" @click="row.toggleDetails">
                                {{ row.detailsShowing ? '-' : '+'}} Info
                                </b-button>
                            </template>
                            <template #row-details="row">
                                    <b-form-textarea
                                    v-model="row.item.extras"
                                    rows="6"
                                    disabled='true'
                                    ></b-form-textarea>    
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                 <EdicionFormasValoradas :transacciones="dataTableDetallePago"></EdicionFormasValoradas>
            </b-col>
           
        </b-row>
    </b-modal>

    <b-modal v-model="isShowModalCancelar" title="Cancelar" size="md" header-bg-variant="dark" header-text-variant="light">
        {{contenidoModalCancelar}}
    </b-modal>

    <b-modal v-model="isShowModalRecibo" size="lg" hide-footer header-bg-variant="dark" header-text-variant="light">
        <DocsTramite :isPublico="false" :tokenUser="token" />
       <!-- <b-embed id="embed1" type="iframe" :src="'data:application/pdf;base64,' + pdfGenerated"></b-embed>--->
    </b-modal>

     <b-modal title="Cancelación de Recibo - Facturas" v-model="isShowModalCancelarRecibo" size="lg" hide-footer header-bg-variant="dark" header-text-variant="light">
         <PanelFacturacion :dataFacturacion="dataFacturacion"/>
         <b-row align-h="center" align="center"><b-col><b-button  variant="danger" @click="cancelarRecibo" size="lg">Cancelar Recibo</b-button></b-col></b-row>
         <b-row align-h="center" align="center" v-if="cfdisContribuyenteActual.length > 0"><h6 class="error" >Para cancelar el recibo, primero debes cancelar las facturas.</h6></b-row>
    </b-modal>

    <b-modal title="Enviar por correo electrónico" v-model="isShowModalEnviarCorreo" size="md" hide-footer header-bg-variant="dark" header-text-variant="light">
        <b-row>
            <b-col class="mt-2"><b><h5><b-icon icon="envelope"/> Ingrese un correo electrónico</h5></b></b-col>
            <b-col cols="12">
                <b-form-input type="email" v-model="correoEnviarRecibo"></b-form-input>
            </b-col>
            <b-col class="mt-2">
                <b-button :disabled="correoEnviarRecibo==null || correoEnviarRecibo==''" variant="success" @click="enviarRecibo(true, true)">Enviar Correo</b-button>
            </b-col>
        </b-row>
    </b-modal>

    <b-modal title="Expediente" v-model="isShowModalExpedienteTramite" size="lg" hide-footer header-bg-variant="dark" header-text-variant="light">
        <b-row style="margin-top:-17px; margin-left:-17px; margin-right:-17px;">
            <b-col style="padding:0px;" >
            <div>
                <iframe style="border:none;" :src="urlExpedienteActual"  scrolling="no"  width="100%" height="2000px" ></iframe>      
            </div>
            </b-col>
        </b-row>
    </b-modal>

    <b-modal title="Crear Expediente" v-model="isShowModalCreaTramite" size="md" hide-footer header-bg-variant="dark" header-text-variant="light">
        <b-row>
            <b-col cols="12">
                <h6>Tipo de trámite</h6>
                <b-form-select v-model="nuevoTramite.idServiceInfo" value-field="idServiceInfo" text-field="nombreServiceInfo" :options="catalogFormas.tramitesInfo"></b-form-select>
            </b-col>
            <b-col cols="12">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                    <b-icon icon="person"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input v-model="nuevoTramite.nombre" type="text" placeholder="Nombre(s) del ciudadano"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="12">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                    <b-icon icon="person"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input v-model="nuevoTramite.apellidoPat" type="text" placeholder="Apellido Paterno"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="12">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                    <b-icon icon="person"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input v-model="nuevoTramite.apellidoMat" type="text" placeholder="Apellido Materno"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="12">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                    <b-icon icon="envelope"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input v-model="nuevoTramite.correo" type="email" placeholder="Correo electrónico"></b-form-input>
                </b-input-group>
            </b-col>          
            <b-col cols="12">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                    <b-icon icon="phone"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input v-model="nuevoTramite.telefono" type="number" placeholder="Teléfono 10 digitos"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="12">
                <h6>Tipo de persona</h6>
                <b-form-select v-model="nuevoTramite.tipoPersona" :options="optionsPersona" size="sm" ></b-form-select>
            </b-col>
      </b-row>
      <b-row align="center"><b-col><br><b-button @click="agregarTramitePresencial"  pill class="btn-back-purple"><b-icon icon="folder-plus"/> Agregar</b-button></b-col></b-row>
    </b-modal>

  </b-container>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.4.1/html2canvas.min.js"></script>
<script>
    import Vue from 'vue';
    import JsonExcel from 'vue-json-excel';
    import { mapState} from 'vuex';
    import VueHtmlToPaper from 'vue-html-to-paper';
    import axios from 'axios';
    import { server, checkAuth, getPostConfig, handledError, getGetConfig } from '@/axios-tools';
    import PanelFacturacion from '@/components/formas-valoradas/PanelFacturacion.vue';
    import DocsTramite from '../cobro/DocsTramite.vue';
import EdicionFormasValoradas from './EdicionFormasValoradas.vue';

    Vue.use(VueHtmlToPaper);
    Vue.component('downloadExcel', JsonExcel)

    export default {
        computed:{ 
            ...mapState ({
            formas: state => state.formas.formas,
            formasClasificado : state => state.formas.formasClasificado,
            isConsultando: state => state.formas.isConsultando,
            msgFormasCancelar: state => state.formas.msgFormasCancelar,
            formasFormModel: state => state.formas.formasFormModel,
            token: state => state.login.token,
            catalogFormas: state => state.formas.catalogFormas,
            totalRecibosMonto : state => state.formas.totalRecibosMonto,
            cfdisContribuyenteActual: state=> state.formas.cfdisContribuyenteActual
            }),
            fieldsToExport : function(){
                let fieldsToExportResume={
                        "Orden pago":"folioOrden",
                        "Fecha orden pago":"fechaOrden",
                        "Fecha vencimiento orden":"fechaVOrden",
                        "Orden generada por":"usuarioOrden",
                        "Recibo":"folioRecibo",
                        "Fecha pagp":"fechaRecibo",
                        "Cobrado por":"usuarioRecibo",
                        "Fecha pago cancelado":"fechaCancelRecibo",
                        "Pago cancelado por":"usuarioCancelRecibo",
                        "Nombre":"nombre",                   
                        "Total":"total",                    
                        "Concepto":"concepto",
                        "Observaciones orden pago":"observacionesOrden",
                    }
                let fieldsToExportComplete={
                        "Orden pago":"folioOrden",
                        "Fecha orden pago":"fechaOrden",
                        "Fecha vencimiento orden":"fechaVOrden",
                        "Orden generada por":"usuarioOrden",
                        "Oficina orden":"oficinaOrden",
                        "Direccion":"direccion",
                        "Departamento":"departamento",
                        "Recibo":"folioRecibo",
                        "Oficina recibo":"oficinaRecibo",
                        "Fecha pago":"fechaRecibo",
                        "Cobrado por":"usuarioRecibo",
                        "Fecha pago cancelado":"fechaCancelRecibo",
                        "Pago cancelado por":"usuarioCancelRecibo",
                        "Nombre":"nombre",                   
                        "Total":"total",                    
                        "Concepto":"concepto",
                        "Observaciones orden pago":"observacionesOrden",
                        
                        
                    }
                let codeClient=this.$route.params.municipio;
                if(codeClient=='chimalhuacan'){
                    return fieldsToExportComplete
                }
                return fieldsToExportResume;
            },
        },
        components: {
            PanelFacturacion,
            DocsTramite,
                EdicionFormasValoradas,
        },
        data() {
            return {
                pdfGenerated: "",
                contenidoModalDetalles: [
                    ["status","ejemplo"],
                    ["ejemplo2","prueba"]
                ],
                contenidoModalReimprimir: [{}],
                contenidoModalCancelar:"",
                isShowModalDetalles: false,
                isShowModalCancelar:false,
                isShowModalCreaTramite:false,
                isShowModalExpedienteTramite:false,

                                
                fieldsToShow:[
                    {key:"folioOrden", label:"Orden Pago"},
                    {key:"folioRecibo", label:"Recibo"},
                    {key:"urlExpediente", label:"Expediente"},
                    {key:"nombre", label:"Nombre"},
                    {key:"concepto", label:"Concepto"},
                    {key:"total", label:"Total"},
                    {key:"acciones", label:"", class: "width-table"}                    
                ],

                dataTableDetallePago:[],
                fieldsTableDetallePago:[
                {key: 'concepto', label: 'Concepto'},
                {key: 'folio', label: 'Recibo'},
                {key: 'fecha', label: 'Fecha'},   
                {key: 'periodo', label: 'Periodo'},                       
                {key: 'importe', label: 'Importe'},
                {key: 'actualizacion', label: 'Act'},
                {key: 'recargo', label: 'Recargo'},
                {key: 'multa', label: 'Multa'},
                {key: 'gastosEjec', label: 'Gastos'},
                {key: 'iva', label: 'IVA'},
                {key: 'subImp', label: 'Subsidio Importe'},
                {key: 'subRec', label: 'Subsidio Recargo'},
                {key: 'subMul', label: 'Subsidio Multa'},
                {key: 'subGto', label: 'Subsidio Gastos'},
                {key: 'total', label: 'Total'},
                {key: 'usuario', label: 'Usuario'},                  
                ],
                isCancelando: false,
                isShowModalOrdenPago:false,
                dataFacturacion:null,
                isShowModalRecibo:false,
                isShowModalCancelarRecibo:false,
                folioReciboCancelar:null,
                isShowModalEnviarCorreo:false,
                folioReciboActual:'',
                correoEnviarRecibo:'',

                /*Para crear un nuevo tramite*/ 
                optionsPersona:[{value:'F', text:'Persona Física (Ciudadano)'}, {value:'M', text:'Representante Legal de Empresa'}, {value:'I', text:'Representante Legal de Institución Pública'}],
                nuevoTramite:{
                    ordenPago:null,
                    recibo:null,
                    idServiceInfo:null,
                    nombre:null,
                    apellidoPat:null,
                    apellidoMat:null,
                    correo:null,
                    telefono:null,
                    tipoPersona:'F',
                },
                urlExpedienteActual:null
            }
        },
        methods: {
            showEnviarCorreo(folio){
                this.folioReciboActual = folio;
                this.correoEnviarRecibo = '';
                this.isShowModalEnviarCorreo = true;
            },
            showCancelarRecibo(folio){
                this.folioReciboCancelar=folio;


                var idxTable = this.indexOfTableByFolio(folio);
                this.dataFacturacion = this.formas[idxTable];
                if(!this.isConsultando && !this.isCancelando && checkAuth(this.$router, this.$store)){
                    this.$store.commit("updateIsConsultando", true);
                    axios(
                        getGetConfig(server.facturasrecibo, null, this.token, {serie:folio.substring(0,2), folio:folio.substring(3,9)})
                    )
                    .then(res => {
                        this.$store.commit("updateCfdisContribuyenteActual", res.data);
                        this.$store.commit("updateIsConsultando", false);
                        this.isShowModalCancelarRecibo=true;
                    }).catch(err => {
                        this.$store.commit("updateIsConsultando", false);
                        handledError(err, server.facturasrecibo, this.$router, this.$store);
                    });
                }

                
            },
            cancelarRecibo(){
                this.isShowModalCancelarRecibo=false;
                if(!this.isConsultando && !this.isCancelando && checkAuth(this.$router, this.$store)){
                    this.$store.commit("updateIsConsultando", true);
                    this.isCancelando=true;
                    this.cleanResults();
                    axios(
                        getPostConfig(server.cancelarRecibo, null, this.token, {serieFolio: this.folioReciboCancelar})
                    )
                    .then(res => {
                        let idxTable = -1;
                        for(let i=0; i<this.formas.length; i++){
                            if(this.formas[i].folioRecibo==this.folioReciboCancelar){
                                idxTable = i;
                                break;  
                            }
                        }
                        this.formas.splice(idxTable, 1);
                        this.contenidoModalCancelar = res.data;
                        this.isCancelando=false;
                        this.$store.commit("updateTotalRecibosMonto", null); //quitamos el total por que ya no coincide con la suma
                        this.$store.commit("updateIsConsultando", false);
                    }).catch(err => {
                        this.$store.commit("updateIsConsultando", false);
                        handledError(err, server.cancelarRecibo, this.$router, this.$store);
                        this.isCancelando=false;
                    });
                }
            },
            indexOfTableByFolio (folio){
                for (var index in this.formas){
                    if(this.formas[index].folioRecibo == folio){
                        return index;
                    }
                }
                return -1;
            },
            reimprimirDocs(folioOrden, folioRecibo){
                if(folioOrden!='NO GENERADA'){
                    this.reimprimirOrden(folioOrden);
                }else if(folioRecibo!='NO PAGADO'){
                    this.reimprimirRecibo(folioRecibo);
                }
            },
            reimprimirRecibo(folio){
                if(!this.isConsultando && !this.isCancelando && checkAuth(this.$router, this.$store)){
                    this.cleanResults();
                    this.$store.commit("updateIsConsultando", true);
                    axios(
                        getGetConfig(server.recibo, null, this.token, {serieFolio:folio.substring(0,2)+folio.substring(2,8)})
                    )
                    .then(res => {
                        this.$store.commit("updatePdfsGenerated", res.data);
                        this.isShowModalRecibo = true;
                        this.$store.commit("updateIsConsultando", false);
                    }).catch(err => {
                        this.$store.commit("updateIsConsultando", false);
                        handledError(err, server.recibo, this.$router, this.$store);
                    });
                }
            },
            enviarRecibo( recibo, fact){
                if(!this.isConsultando && !this.isCancelando && checkAuth(this.$router, this.$store)){
                    this.cleanResults();
                    this.$store.commit("updateIsConsultando", true);
                    this.isShowModalEnviarCorreo = false;
                    axios(
                        getGetConfig(server.enviarrecibo, null, this.token, {serieFolio:this.folioReciboActual, correo:this.correoEnviarRecibo, recibo:recibo, fact:fact})
                    )
                    .then(() => {
                        alert("El correo ha sido enviado a "+ this.correoEnviarRecibo);
                        this.$store.commit("updateIsConsultando", false);
                    }).catch(err => {
                        this.$store.commit("updateIsConsultando", false);
                        handledError(err, server.enviarrecibo, this.$router, this.$store);
                    });
                }                
            },
            downloadRecibo(){
                this.downloadB64Pdf(this.pdfGenerated, "formato.pdf");                
            },
            cleanResults(){
                this.$store.commit("updateMsgFormasCancelar", '');
                this.$store.commit("updateTotalRecibosMonto", null);
            },
            reimprimirOrden(folio){
                if(!this.isConsultando && !this.isCancelando && checkAuth(this.$router, this.$store)){
                    this.cleanResults();
                    this.$store.commit("updateIsConsultando", true);
                    axios(
                        getPostConfig(server.ordenpagopdf, this.formasFormModel, this.token, {ordenPago:folio.substring(0,3)+folio.substring(3,9)})
                    )
                    .then(res => {
                        this.$store.commit("updatePdfsGenerated", res.data);
                        this.isShowModalRecibo = true;
                        this.$store.commit("updateIsConsultando", false);                        
                    }).catch(err => {
                        this.$store.commit("updateIsConsultando", false);
                        handledError(err, server.recibo, this.$router, this.$store);
                    });
                }
            },
            showDetalles(orden, recibo){
                if(orden == 'NO GENERADA' && recibo == 'NO PAGADO'){
                    alert('Aún no existe información del pago');

                }else if(!this.isConsultando && !this.isCancelando && checkAuth(this.$router, this.$store)){
                    this.$store.commit("updateIsConsultando", true);
                    axios(
                        getPostConfig(server.detallePago, null, this.token, {orden:orden, recibo:recibo})
                    )
                    .then(res => {
                        this.dataTableDetallePago = res.data;
                        this.isShowModalDetalles = true;
                        this.$store.commit("updateIsConsultando", false);                        
                    }).catch(err => {
                        this.$store.commit("updateIsConsultando", false);
                        handledError(err, server.recibo, this.$router, this.$store);
                    });
                }
            },
            indexOfTable (idElement){
                for (var index in this.formas){
                    if(this.formas[index].folio+this.formas[index].pagado == idElement){
                        return index;
                    }
                }
                return -1;
            },
            cancelarOrden(folioOrden){
                if(!this.isConsultando && !this.isCancelando && checkAuth(this.$router, this.$store)){
                    this.isCancelando=true;
                    this.cleanResults();
                    axios(
                        getPostConfig(server.cancelarorden, null, this.token, {serieFolio: folioOrden})
                    )
                    .then(res => {
                        let idxTable = -1;
                        for(let i=0; i<this.formas.length; i++){
                            if(this.formas[i].folioOrden==folioOrden){
                                idxTable = i;
                                break;  
                            }
                        }
                        this.formas.splice(idxTable, 1);
                        this.contenidoModalCancelar = res.data;
                        this.isCancelando=false;
                        this.isShowModalCancelar = true;
                    }).catch(err => {
                        handledError(err, server.cancelarorden, this.$router, this.$store);
                        this.isCancelando=false;
                    });
                }
            },
            cancelarTramite(tramite){
                if(tramite.folioRecibo!='NO PAGADO' ){
                    this.showCancelarRecibo(tramite.folioRecibo);
                }else if(tramite.folioOrden!='NO GENERADA' && (tramite.fechaCancelRecibo=='' || tramite.fechaCancelRecibo==null)){
                    this.cancelarOrden(tramite.folioOrden);
                }
            },
            agregarTramitePresencial(){
                if(!this.isConsultando && !this.isCancelando && checkAuth(this.$router, this.$store)){
                    this.$store.commit("updateIsConsultando", true);
                    this.isShowModalCreaTramite=false;
                    axios(
                        getPostConfig(server.generartramite, this.nuevoTramite, this.token, {})
                    )
                    .then(res => {
                        const urlExpediente = res.data;
                        for(let idxr in this.formas){
                            if(this.formas[idxr].folioRecibo==this.nuevoTramite.recibo){
                                this.formas[idxr].urlExpediente = urlExpediente;
                            }
                        }
                        this.$store.commit("updateIsConsultando", false);                        
                    }).catch(err => {
                        this.$store.commit("updateIsConsultando", false);
                        handledError(err, server.generartramite, this.$router, this.$store);
                    });
                }
            },
            mostrarCrearTramite(orden, recibo){
                this.nuevoTramite.ordenPago=orden;
                this.nuevoTramite.recibo=recibo;
                this.nuevoTramite.idServiceInfo=null;
                this.nuevoTramite.nombre=null;
                this.nuevoTramite.apellidoPat=null;
                this.nuevoTramite.apellidoMat=null;
                this.nuevoTramite.correo=null;
                this.nuevoTramite.telefono=null;
                this.nuevoTramite.tipoPersona='F';

                this.isShowModalCreaTramite=true;
            },
            mostrarExpedienteTramite(url){
                this.urlExpedienteActual = url;
                this.isShowModalExpedienteTramite=true;
            },
            descargarExcel(){
                var data= 'data:application/pdf;base64,'+this.formasClasificado.excelXls;              
                var downloadExcel = document.createElement('a');
                downloadExcel.setAttribute('href', data);
                downloadExcel.setAttribute('download', "reporte.xlsx");
                downloadExcel.click();  
            },
        }
    }
</script>
<style>
.width-table  {
            width: 10%;
            text-align: center;
        }
.badge-ok{
    background-color: rgba(63, 166, 60, 0.2); color:rgb(63, 166, 60); padding:7px;
}
.badge-error{
   background-color: rgba(255, 175, 0, 0.2); color:rgb(255, 175, 0); padding:7px;
}
</style>